/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, plan: NonNullable<unknown> }} Report_Meta_OneInputs */



/**
* | output |
* | --- |
* | "{range} · 1 day · {plan} plan" |
*
* @param {Report_Meta_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_meta_one = /** @type {((inputs: Report_Meta_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Meta_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.range} · 1 Tag · Tarif ${i?.plan}`)
	return /** @type {LocalizedString} */ (`${i?.range} · 1 day · ${i?.plan} plan`)
});